import { useState, useContext } from 'react';
import axios from 'axios';
import '../styles/swicthcss.css';
import { projectContext, loadingContext, urlValue, unfolder, openAlert, useTranslate } from '../lib';
import { Alerts } from './common/Alerts'
import BoxInfo from './common/BoxInfo'
import { InputNesting } from './common/Inputs/Input'

export function CustomChat({ isModalOpen, closeModal, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext);
  const [loading, setLoading] = useContext(loadingContext);
  const [alert, setAlert] = useState({ title: '', visible: false });
  const [error, setError] = useState({ name: "" });
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [clientBubbleImage, setClientBubbleImage] = useState(null);
  const [agentBubbleImage, setAgentBubbleImage] = useState(null);
  const [customChatName, setCustomChatName] = useState('');
  const { t } = useTranslate();
  const handleFileChange = (type) => (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validFormats = ['image/png', 'image/svg+xml', 'image/jpeg'];
    if (!validFormats.includes(file.type)) {
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.validImage2'), visible: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
      return;
    }

    if (type === 'background') setBackgroundImage(file);
    if (type === 'client') setClientBubbleImage(file);
    if (type === 'agent') setAgentBubbleImage(file);
  };

  const validateInputs = () => {
    const nameExp = /^[A-Za-z0-9-,._'\s]+$/g;
    
    if (customChatName == '') {
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.customChatValidName'), visible: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
      return false;
    }
    else if (!nameExp.test(customChatName)) {
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.customChatName'), visible: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
      return false;
    }

    if (!customChatName || !backgroundImage || !clientBubbleImage || !agentBubbleImage) {
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.customChatFiles'), visible: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
      return false;
    }

    return true;
  };

  const uploadFiles = async () => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
  
    const formData = new FormData();
    formData.append('backgroundImage', backgroundImage);
    formData.append('clientBubbleImage', clientBubbleImage);
    formData.append('agentBubbleImage', agentBubbleImage);
  
    try {
      const response = await axios.post(`${urlValue}/studio/customchat`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'user_id': id,
          'project_id': selectedProject.id,
          'access-token': token,
          'name': customChatName,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
      });
      console.log('Response:', response.data);
      update();
      openAlert('#alert-ac', () => { setAlert({title: t('alerts.customChatSaved'), visible: true}) }, 4000, () => { setAlert({...alert, visible: false}) });
    } catch (error) {
      console.log('Error trying to create custom chat:', error);
    }
  };

  const saveCustomChat = async () => {
    if (!validateInputs()) return;

    setLoading(true);
    try {
      await uploadFiles();
      // setCustomChatName('');
      // setBackgroundImage(null);
      // setClientBubbleImage(null);
      // setAgentBubbleImage(null);
    } catch (error) {
      setError("Failed to save custom chat.");
      console.error("Error uploading files", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="custom-chat-form">

        <InputNesting
                  containerClass="mr-2"
                  id="custom-chat"
                  type="text"
                  title={t('menu.customChatName')}
                  onChange={(e) => setCustomChatName(e.target.value)}
                />


        <div className="input" style={{ marginTop: 25 }}>
          <div className="d-flex flex-column justify-end ml-2" style={{ minWidth: 100 }}>
          <BoxInfo
                      id="backgroundImage-tp"
                      place="top"
                      containerClass='mr-0-5 z-15 '
                            render={t('menu.uploadBackgroundTooltip')}
                          />
            <span>{t('menu.uploadBackgroundForChat')}</span>
            <label className="custom-file mt-4" style={{ width: '100%' }}>
              <input
                onChange={handleFileChange('background')}
                type="file"
                accept="image/png, image/svg+xml, image/jpeg"
              />
              {t('menu.uploadBackground')}
            </label>
          </div>
        </div>

        <div className="input" style={{ marginTop: 25 }}>
          <div className="d-flex flex-column justify-end ml-2" style={{ minWidth: 100 }}>
          <BoxInfo
                      id="clientBubbleImage-tp"
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={t('menu.uploadClientBubbleTooltip')}
                      />
            <span>{t('menu.uploadClientBubbleForChat')}</span>
            <label className="custom-file mt-4" style={{ width: '100%' }}>
              <input
                onChange={handleFileChange('client')}
                type="file"
                accept="image/png, image/svg+xml, image/jpeg"
              />
              {t('menu.uploadClientBubble')}
            </label>
          </div>
        </div>

        <div className="input" style={{ marginTop: 25 }}>
          <div className="d-flex flex-column justify-end ml-2" style={{ minWidth: 100 }}>
          <BoxInfo
                      id="agentBubbleImage-tp"
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={t('menu.uploadAgentBubbleTooltip')}
                      />
            <span>{t('menu.uploadAgentBubbleForChat')}</span>
            <label className="custom-file mt-4" style={{ width: '100%' }}>
              <input
                onChange={handleFileChange('agent')}
                type="file"
                accept="image/png, image/svg+xml, image/jpeg"
              />
              {t('menu.uploadAgentBubble')}
            </label>
          </div>
        </div>

        <div className='cont-buttons mt-5 w-100' style={{  marginTop: "20px", display: "flex" }}>
          <div className="buttons d-flex flex-row justify-end pr-3">
            <button type="button" onClick={saveCustomChat} disabled={loading} className="create-customchat btn-primary btn-bottom btn-bottom-create" style={{ backgroundColor: "#0087FF" }}>
              {t('common.save')}
            </button>
          </div>
        </div>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
      </div>
    </>
  );
}
